import { action } from 'satcheljs';
export var owaSuiteHeaderRendered = action('owaSuiteHeaderRendered');
//# sourceMappingURL=owaSuiteHeaderRendered.js.map